import styled from 'styled-components';

export const MainProfileStyle = {
  Container: styled.div`
    width: 250px;
    margin: 0 auto;
  `,
  ProfileImage: styled.div`
    width: 140px;
    height: 140px;
    border-radius: 200px;
    margin: 0 auto;
    background: url("/assets/profile.jpg") no-repeat 0 0;
    background-size: 200px auto;
    background-position: 50%;
  `,
  ProfileTitle: styled.div`
    width: 100%;
    margin-top: 20px;
    font-size: 16px;
    text-align: center;

    h2 {
      font-size: 1.5em;
      font-weight: 600;
      color: ${({ theme }) => theme.color.black};
    }
    h3 {
      font-size: 0.8em;
      color: ${({ theme }) => theme.color.grey};
      line-height: 2em;
    }
    p {
      &:first {
        margin-top: 10px;
      }
      font-size: 0.7em;
      color: ${({ theme }) => theme.color.black};
      line-height: 2em;
    }
  `,
};

export const CareerStyle = {
  Container: styled.div`
    font-size: 16px;
    margin: 3em auto 1em;
    width: 250px;

    h2 {
      font-size: 25px;
      font-weight: 600;
      color: ${({ theme }) => theme.color.black};
      margin-bottom: 20px;
      text-align: center;
    }
  `,
};
